import { NrbUtils } from './../nrb-utils';

export class NrbValidator {
    private static format = /^[0-9]{26}$/;
    private static weights = [
        1, 10,  3, 30,  9,
        90, 27, 76, 81, 34,
        49,  5, 50, 15, 53,
        45, 62, 38, 89, 17,
        73, 51, 25, 56, 75,
        71, 31, 19, 93, 57
    ];
    private static divisor = 97;

    public static isValid(value: string | null | undefined): boolean {
        if (!value) return true;

        let nrbz = value.replace(/ /g, ''); //nr rachunku znormalizowany
        if (NrbUtils.isIBAN(nrbz)) {
            if (nrbz.substring(0, 2) !== 'PL') { // tylko dla niepolskich IBAN nie walidujemy formatu
                nrbz = NrbUtils.extractNrb(nrbz);
                if (!isNaN(Number(nrbz[0]))) { // jesli po dwoch pierwszych literach w całym IBAN jest cyfra - to olewamy walidacje formatu
                    return true;
                } else {
                    return this.format.test(nrbz);
                }
            }
            nrbz = NrbUtils.extractNrb(nrbz);
        }

        if (!NrbValidator.format.test(nrbz)) {
            return false;
        }

        nrbz = `${nrbz.substr(2)}2521${nrbz.substr(0, 2)}`;

        let sum = 0;
        const nrbLength = nrbz.length;

        for (let i = 0; i < NrbValidator.weights.length; ++i) {
            sum += Number(nrbz[nrbLength - 1 - i]) * NrbValidator.weights[i];
        }

        return sum % NrbValidator.divisor === 1;
    }
}
